import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostValidatePasswordAuth = () => {
  return useMutation({
    mutationFn: authService.postValidatePasswordAuth,
    throwOnError: false,
  });
};
